<template>
    <div class="menu-btn">
        <!--<ul>
            <li :class="{cur:path=='/study'}" @click="gopage('/study');" >空中课堂</li>
            <li :class="{cur:path=='/xueersi'}" @click="gopage('/xueersi');" >学而思</li>
            <li :class="{cur:path=='/child/少儿编程'}" @click="gopage('/child/少儿编程');" >少儿编程</li>
            <li :class="{cur:path=='/yundangke'}" @click="gopage('/yundangke');" >微影云党课</li>
            <li :class="{cur:path=='/weike'}" @click="gopage('/weike');" >名师助学</li>
        </ul>-->
        <van-tabs v-model="activeName" @click="handleClick" :ellipsis=false color="#00beff" title-active-color="#00beff">
                <van-tab title="空中课堂" name="/study"></van-tab>
                <!--<van-tab title="学而思" name="/xueersi"></van-tab>-->
                <van-tab title="少儿编程" name="/child/少儿编程"></van-tab>
                <van-tab title="微影云党课" name="/yundangke"></van-tab>
                <van-tab title="名师助学" name="/weike"></van-tab>
                <van-tab title="口语" name="/kouyu"></van-tab>
        </van-tabs>
    </div>

    
</template>

<script>
import router from 'vue-router';
import { Tab, Tabs} from 'vant';
import 'vant/lib/tab/style';
import 'vant/lib/tabs/style';

export default{
    name: 'TopMenu',
    data(){
        console.log("route:",this.$route);
        return{
            path:this.$route.path,
            activeName: this.$route.path
        }

    },
    watch:{
        path:{
            handler(newValue, oldValue) {
                console.lg(newValue);
            },  
        },
        deep: true
    },
    methods:{
        gopage(pagehash){
            if(pagehash=='/kouyu'){
                window.location="zgapp://dl/oral";
                this.$router.push({path:"/study"});
            }else{
                this.$router.push({path:pagehash});  
            }
            
        },
        handleClick(name, title) {
            console.log(this.path);
            this.gopage(name);
        }
    },
    components: {
        Tab,
        Tabs
    }
}
</script>

<style lang="less" scoped>
    .menu-btn{
        position: fixed;
        top: 0;
        z-index: 10;
        width: 100%;
        max-width: 1100px;
    }
    .menu-btn ul {
        /*display: flex;*/
        justify-content: space-between;
        font-size: 0.373333rem;
        padding: 0.160000rem 0.100000rem 0.06667rem 0.1rem;
        width: 100%;
    }

    .menu-btn li {
        border-radius: 0.293333rem;
        background: #eaf5ff;
        height: 0.586667rem;
        line-height: 0.586667rem;
        padding: 0  0.320000rem;
        color: #1984ff;
        display: block;
        float: left;
    }

    .menu-btn li a {
        color: #1984ff;
    }

    .menu-btn li.cur {
        background: #00beff;
        color: #fff;
    }

    .menu-btn li.cur a {
        color: #fff;
    }     
</style>   